module.exports = __webpack_public_path__ + "static/HandBag2_zpscy4cl4fo-af0940b66646c28671fda548a86c3e8e.jpg";